export default "__VITE_ASSET__DUUQ_gpy__"